module.exports = __webpack_public_path__ + "img/home-banner3.38f1ad6a.jpeg";